import React, { FC, ReactChild } from "react";
import { flexCenter, CAUTION_SIZE } from "../../utils/styles";
import { IMAGES } from "../../utils/images";
import { container, icon, regularSize, largeSize, smallSize } from "./styles";
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { isMobile } from "../../utils/helpers";
interface CautionProps {
  text: string | ReactChild;
  size: CAUTION_SIZE;
  width?: string;
}

/**
 * Info alert component
 *
 * @param {*} { size, text, width = "100%" }
 * @return {*}
 */
const Caution: FC<CautionProps> = ({ size, text, width = "100%" }) => {
  let containerStyle = isMobile() ? smallSize : regularSize;
  switch (size) {
    case CAUTION_SIZE.LARGE:
      containerStyle = largeSize;
      break;
    case CAUTION_SIZE.REGULAR:
    default:
      break;
  }

  return (
    <div
      css={css`
        ${flexCenter} ${container(width)} ${containerStyle}
      `}
    >
      <img src={IMAGES.IC_INFO} alt="Info Icon" css={icon} />
      <div>{text}</div>
    </div>
  );
};

export default Caution;
